import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import ClaimsIcon from "@redotech/redo-icons/alert-hexagon.svg";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { NEEDS_ACTION } from "@redotech/redo-return-operations-common/views/needs-action";
import { ViewTypesNames } from "@redotech/redo-views-common/views";
import { createClaimsListAdvancedFilters } from "../../returns-filters";
import { CLAIM_CARD_COPY } from "./claim-card-copy";
import { returnRecordSource } from "./return-record-source";

export const CLAIMS_SOURCE = returnRecordSource({
  type: "claims",
  recordType: ReturnTypeEnum.CLAIM,
  Icon: ClaimsIcon,
  availability: {
    capabilities: ["oms", "packageProtection", "returns"],
    permissions: [
      ReturnsAndClaimsPermissions.MANAGE_PACKAGE_PROTECTION_CLAIM,
      ReturnsAndClaimsPermissions.MANAGE_CARRIER_CLAIM,
    ],
  },
  viewType: ViewTypesNames.CLAIMS,
  countSavedViews: false,
  category: "returns",
  tableFilters: ({ language, merchantRpcClient }) =>
    createClaimsListAdvancedFilters({ language, merchantRpcClient }),
  entries: NEEDS_ACTION.claims,
  cardCopy: CLAIM_CARD_COPY,
  copy: (t) => ({
    recordsLabel: t("Claims"),
    allLabel: t("All claims"),
    searchAllLabel: (query) =>
      t("Search all claims for “{{query}}”", { query }),
    recordCount: (count) => t("{{count}} claims", { count }),
    viewRecords: (count) => t("View {{count}} claims", { count }),
    viewLabel: t("View claims"),
    processAll: (count) => t("Process all {{count}} claims", { count }),
    resolvePrompt: (count, view) =>
      `Resolve the ${count} claims flagged “${view}”`,
  }),
  create: ReturnTypeEnum.CLAIM,
});
